import { setSpecificMessage, safeInteger } from "valibot";
setSpecificMessage(
  safeInteger,
  (issue) => `Entier sûr invalide: reçu ${issue.received}`,
  "fr"
);